import { put, call, takeEvery } from 'redux-saga/effects'

import { FETCH_STATUSES } from '../actions/types'
import { fetchStatusesSuccess, fetchStatusesFailure } from '../actions/statusActions'
import statusService from '../services/statusService'

export function* handleFetchStatuses(action) {
  try {
    const { accessToken } = action.payload
    // Fetch data from API
    const results = yield call(statusService.fetchStatuses, accessToken)

    yield put(fetchStatusesSuccess(results))
  } catch (err) {
    console.error(err, 'Error fetching statuses')
    yield put(fetchStatusesFailure(err))
  }
}

function* watchStatusSagas() {
  yield takeEvery(FETCH_STATUSES, handleFetchStatuses)
}

export default watchStatusSagas
